<img
  [ngStyle]="imageConfig.ngStyle"
  [ngClass]="imageConfig.ngClass"
  [src]="imageUri"
  [alt]="imageConfig.alt"
  class="placeholder"
  crossorigin="anonymous"
/>
